<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Produção"
            description="Exportação de produção em XLS"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="row">
        <div class="grid-itens">
          <div v-for="(item, index) in cards" :key="index" class="item-flex">
            <router-link :to="item.link">
              <div class="item">
                <i v-if="item.icone !== false" :class="item.icone"></i>
                <img v-else :src="item.imagem" alt="" />
                <h3>
                  {{ item.titulo }}
                </h3>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'

export default {
  name: 'Producao',
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.producao
    },
  },
  data() {
    return {
      step: 0,
      selected: null,
      lista: [
        { text: 'Nome do procedimento', value: 'no_proced' },
        { text: 'Código do procedimento', value: 'co_proced' },
        { text: 'Código do CBO', value: 'co_cbo' },
        { text: 'Descrição do CBO', value: 'no_cbo' },
        { text: 'CPF do profissional', value: 'profissional' },
        { text: 'CNES', value: 'cnes' },
        { text: 'Unidade de Saúde', value: 'no_unidade_saude' },
      ],
      listaAdicionar: [],
      agrupar: [],
    }
  },
  methods: {
    selectItem(item) {
      this.selected = item
    },
    nextStep() {
      if (this.step < 3) {
        this.step++
      }
    },
    prevStep() {
      if (this.step > 0) {
        this.step--
      }
    },
    moveItem(direction) {
      if (this.selected) {
        const isAlreadyInRightList = this.listaAdicionar.includes(this.selected)
        const isAlreadyInLeftList = this.lista.includes(this.selected)

        if (direction === 'right' && !isAlreadyInRightList) {
          this.listaAdicionar.push(this.selected)
          const index = this.lista.indexOf(this.selected)
          if (index !== -1) {
            this.lista.splice(index, 1)
          }
          this.selected = null
        } else if (direction === 'left' && !isAlreadyInLeftList) {
          this.lista.push(this.selected)
          const index = this.listaAdicionar.indexOf(this.selected)
          if (index !== -1) {
            this.listaAdicionar.splice(index, 1)
          }

          this.selected = null
        }
      }
    },
  },
}
</script>

<style scoped></style>
